/**
* [Flags]
*/
export var FolderPermission;
(function (FolderPermission) {
    FolderPermission[FolderPermission["None"] = 0] = "None";
    FolderPermission[FolderPermission["CanUse"] = 1] = "CanUse";
    FolderPermission[FolderPermission["CanOpen"] = 2] = "CanOpen";
    FolderPermission[FolderPermission["CanView"] = 4] = "CanView";
    FolderPermission[FolderPermission["CanEdit"] = 8] = "CanEdit";
    FolderPermission[FolderPermission["CanAdd"] = 16] = "CanAdd";
    FolderPermission[FolderPermission["CanDelete"] = 32] = "CanDelete";
    FolderPermission[FolderPermission["CanAdministrate"] = 64] = "CanAdministrate";
    FolderPermission[FolderPermission["CanSeeHidden"] = 128] = "CanSeeHidden";
    FolderPermission[FolderPermission["CanSeeArchived"] = 256] = "CanSeeArchived";
    FolderPermission[FolderPermission["CanViewBrowsePage"] = 512] = "CanViewBrowsePage";
    FolderPermission[FolderPermission["AllButAdmin"] = 575] = "AllButAdmin";
    FolderPermission[FolderPermission["All"] = 1023] = "All";
})(FolderPermission || (FolderPermission = {}));
;
